import { CrmCarousel } from './crm-carousel'
export { CrmCarousel }
